import React, { memo } from 'react';
import { LoadingSpinStyle } from './style'
export default memo(function LoadingSpin({ show, ...options }) {
    return (
        show &&
        <LoadingSpinStyle {...options} />
    );
});